import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { getRoomLabelsTranslated } from 'components/Offer/hooks/useGetRoomLabels';
import { getOfferHasGhaOrGvrPreferredRate } from 'modules/sapiSearch/selectors';
import { SearchOffer } from 'modules/sapiSearch/slice';
import { getShouldShowYourChoiceTag } from 'modules/search/selectors';
import { toggle } from 'opticks';
import { Box } from '@daedalus/atlas/helpers/Box';
import { Text } from '@daedalus/atlas/Text';
import { getCancellationDeadline } from '@daedalus/core/src/offer/business/cancellationPenalties';
import { getRoomLabels, roomLabels } from '@daedalus/core/src/offer/business/getRoomLabels';
const _exp = /*#__PURE__*/() => Text;
const TextContainer = /*#__PURE__*/styled(_exp())({
  name: "TextContainer",
  class: "t1046njt",
  propsAsIs: true
});
const FreeCancellationDeadlineText: React.FC<{
  offer: SearchOffer;
}> = ({
  offer
}) => {
  const {
    formatDate,
    formatMessage
  } = useIntl();
  const freeCancellationDeadline = getCancellationDeadline(offer.cancellationPenalties);
  const date = formatDate(freeCancellationDeadline, {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    timeZone: 'UTC'
  });
  return <Text colorPath="content.neutral.c600" variant="bodyXS">
      {formatMessage(roomLabels.freeCancellationDeadline, {
      date
    })}
    </Text>;
};
interface Props {
  offer: SearchOffer;
}

// Added as a part of 70766997-desktop-hotel-card-secondary-offers
export const RoomLabelsText: React.FC<Props> = ({
  offer
}) => {
  const {
    formatMessage
  } = useIntl();
  const shouldShowYourChoice = useSelector(getShouldShowYourChoiceTag(offer));
  const offerHasGhaOrGvrPreferredRate = useSelector(state => getOfferHasGhaOrGvrPreferredRate(state, offer));
  const shouldShowFreeCancellationDate = offerHasGhaOrGvrPreferredRate && toggle('feature-free-cancellation-date-gha-gvr-preferred-rate-offers', false, true);
  const labels = getRoomLabels({
    offer,
    shouldShowYourChoice,
    shouldShowFreeCancellationDate
  });
  const filteredLabels = labels.filter(label => label?.id !== roomLabels.freeCancellationDeadline.id);
  const translatedLabels = getRoomLabelsTranslated({
    labels: filteredLabels,
    formatMessage
  });
  const isSingleYourChoiceLabel = shouldShowYourChoice && translatedLabels.length === 1;
  const fullText = translatedLabels.join(' \u00B7 ');
  const otherLabels = shouldShowYourChoice ? [...translatedLabels].splice(1, 1).join(' \u00B7 ') : translatedLabels.join(' \u00B7 ');
  return <Box display="flex" flexDirection="column" gap="s100">
      {translatedLabels?.length > 0 && <Box display="flex" alignItems="flex-start" title={fullText}>
          {shouldShowYourChoice && <TextContainer dataId="RoomLabels" variant="bodyXS" className={cx('__isYourChoice')}>
              {translatedLabels[0]}
              {translatedLabels.length > 1 && ' \u00B7 '}
            </TextContainer>}

          {!isSingleYourChoiceLabel && <TextContainer colorPath="content.neutral.c600" variant="bodyXS" dataId="RoomLabels">
              {otherLabels}
            </TextContainer>}
        </Box>}

      {shouldShowFreeCancellationDate && <FreeCancellationDeadlineText offer={offer} />}
    </Box>;
};

require("./RoomLabelsText.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./RoomLabelsText.tsx");